import React, {useContext} from "react";
import parse from 'html-react-parser'; // This Method use to convert Raw-Html string into HTML Elements.
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => { // This component is used to show all Estimate notes.
    let Record = useContext(RecordsManagementContext)
    return (
        <div className="row mt-3">
            <div className="col-md-12">
                <div className="contact-information">
                    <ul className="contact-info-list pl-0 mb-0">
                        <li><h6>Estimate Notes</h6></li>
                        <li>
                            {Record.CP_PageDetails.EstimateNotes.length <= 0 ?
                                <div style={{fontSize:"0.9rem"}}>No Estimate Notes Are Added To This Job</div>
                                :
                                <table className="table estimated-cost-tbl estimate-notes-tb">
                                    <thead>
                                    <tr>
                                        <th scope="col">Date Added</th>
                                        <th scope="col">Rep</th>
                                        <th scope="col">Notes/Details</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {Record.CP_PageDetails.EstimateNotes.map((estimate_note) => {
                                        return (
                                            <EstNoteDetails EstimateNote={estimate_note} key={estimate_note.Id}/>)
                                    })}
                                    </tbody>
                                </table>
                            }
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
};

const EstNoteDetails = (props) => {
    let EstNote = props.EstimateNote
    return (
        <tr>
            <td id="td-cls" data-label="Date Added" style={{fontSize:"0.9rem",paddingTop: "0.5%"}}>{EstNote.Date}</td>
            <td id="td-cls" data-label="Rep" style={{fontSize:"0.9rem", paddingTop: "0.5%"}}>{EstNote.Rep}</td>
            <td id="td-cls" data-label="Notes/Details" style={{fontSize:"0.9rem",paddingTop: "0.5%"}} >{parse(`${EstNote.Note.replace(/&nbsp;/g, "<br>")}`)}</td>
        </tr>
    );
}